<script setup>
import {Head, useForm, usePage} from '@inertiajs/inertia-vue3';
import MainLayout from '../../../Layouts/MainLayout';
//import Icone from '../../../Componentes/Global/Icone';
import useRotas from '../../../Composables/useRotas';
import { useQuasar } from 'quasar';
import FormRow from '../../../Componentes/Forms/FormRow';
import FormInput from '../../../Componentes/Forms/FormInput';
import FormGroupLabel from '../../../Componentes/Forms/FormGroupLabel';
import { cnpj } from 'cpf-cnpj-validator';
import isEmail from 'validator/lib/isEmail';
import {defineProps, onMounted, ref} from "vue";

const $q = useQuasar();
const route = useRotas();

const props = defineProps({
    user: Object,
});

console.log(props.user);

const listaEstadoUF = ref([]);

const atualizarListaEstadoUF = async () => {
    const response = await fetch(route('utilidades.listaEstadoUF'), {
        method: 'GET',
        credentials: 'include'
    });

    const lista = await response.json();

    lista.forEach(estado => {
        listaEstadoUF.value.push(estado);
    });

}

onMounted(async() =>{
    await atualizarListaEstadoUF();

    // pega o celular da tabela de usuarios, caso não tiver, tenta encontrar um na tabela de telefones que seja celular
    form.celular = (usePage().props.value.auth?.usuario?.telefone_celular) ? usePage().props.value.auth?.usuario?.telefone_celular :
        (props.user?.telefones_cliente?.filter((item) => item.ordem === '1' && item.nome === 'Celular').length > 0) ?
            props.user?.telefones_cliente?.filter((item) => item.ordem === '1' && item.nome === 'Celular')[0]['telefone']
            : '';

    if(props.user.enderecos_cliente?.[0]?.uf_endereco){
        form.estado = props.user.enderecos_cliente?.[0]?.uf_endereco;
        form.cidade = props.user.enderecos_cliente?.[0]?.cidade_endereco;
        form.bairro = props.user.enderecos_cliente?.[0]?.bairro_endereco;
        form.endereco = props.user.enderecos_cliente?.[0]?.rua_endereco;
    }else{
        form.estado = props.user.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.estado?.codigo_uf;
        form.cidade = props.user.enderecos_cliente?.[0]?.rua?.bairro?.cidade?.nome;
        form.bairro = props.user.enderecos_cliente?.[0]?.rua?.bairro?.nome;
        form.endereco = props.user.enderecos_cliente?.[0]?.rua?.tipo + ' ' + props.user.enderecos_cliente?.[0]?.rua?.nome;
    }
});

const form = useForm({
    id: props.user?.id,
    nomeUsuario:  usePage().props.value.auth.usuario.username, // 'Teste Novo',
    senha: null, // '123456789Aa@',
    nomeFantasia: props.user?.nome_fantasia, // 'Teste Novo',
    razaoSocial: props.user?.razao_social, // 'Teste Novo',
    cnpj: props.user?.cpf_cnpj, // '04884383060',
    inscricaoEstadual: props.user?.rg_ie, // '11111111111',
    nomeResponsavel: props.user?.nome_completo, // 'Teste Novo',
    email: props.user?.email, // 'teste@teste.com',
    celular: null,
    telefone:       (props.user?.telefones_cliente?.filter((item) => item.ordem === '1' && item.nome === 'Residencial').length > 0) ? props.user?.telefones_cliente?.filter((item) => item.ordem === '1' && item.nome === 'Residencial')[0]['telefone'] : '', // '11954125910',
    telefoneRecado: (props.user?.telefones_cliente?.filter((item) => item.ordem === '1' && item.nome === 'Recados').length > 0) ? props.user?.telefones_cliente?.filter((item) => item.ordem === '1' && item.nome === 'Recados')[0]['telefone'] : '', // '11954125910',
    cep: (props.user.enderecos_cliente?.[0]?.cep_rua).padStart(8, '0'), // '09667000',
    estado: null, // 'Teste Novo',
    cidade: null, // 'Teste Novo',
    bairro: null, // 'Teste Novo',
    endereco: null, // 'Teste Novo',
    numero: props.user.enderecos_cliente?.[0]?.numero, // 'Teste Novo',
    complemento: props.user.enderecos_cliente?.[0]?.complemento_endereco, // 'Teste Novo',
    referencia: props.user.enderecos_cliente?.[0]?.observacao_endereco, // 'Teste Novo',
    referenciaBancaria: null, // 'Teste Novo',
    informacoesExtras: props.user?.dados_bancarios_cliente?.[0]?.informacoes_extras,
})

const campos = {
    tituloAcesso: {
        tipo: 'titulo',
        texto: 'Dados de Acesso'
    },
    nomeUsuario: {
        tipo: 'campo',
        largura: 6,
        label: 'Apelido',
        dica: 'Este será o nome que aparecerá no site para outros usuários, não pode ser um email',
        autocomplete: 'username',
        icon: 'mdi-account',
        required: true,
        regras: [
            val => val && !/(.com|@)/.test(val) || 'Este campo não pode ser um email.',
            val => val && !isEmail(val) || 'Este campo não pode ser um email',
            val => val && val.length > 5 || 'Deve ter mais de 5 caracteres'
        ]
    },
    /*senha: {
        tipo: 'campo',
        largura: 6,
        label: 'Senha',
        type: 'password',
        autocomplete: 'password',
        icon: 'mdi-key-variant',
        required: true,
        regras: [
            val => val && val.length >= 6 || 'Senha muito curta, ela deve ter 6 ou mais caracteres',
            val => val && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])/.test(val) || 'A senha deve ter ao menos uma letra minuscula, uma maiuscula e um caractere especial'
        ]
    },*/
    tituloPessoais: {
        tipo: 'titulo',
        texto: 'Dados Pessoais'
    },
    nomeFantasia: {
        tipo: 'campo',
        largura: 6,
        label: 'Nome Fantasia',
        autocomplete: 'name',
        icon: 'mdi-factory',
        required: true,
        regras: []
    },
    razaoSocial: {
        tipo: 'campo',
        largura: 6,
        label: 'Razão Social',
        autocomplete: 'name',
        icon: 'mdi-factory',
        required: true,
        regras: []
    },
    cnpj: {
        tipo: 'campo',
        largura: 6,
        label: 'CNPJ',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: true,
        readonly: true,
        mascara: '##.###.###/####-##',
        regras: [
            val => val && val.length === 14 || 'Por favor, digite o seu CNPJ igual está no documento.',
            val => val && cnpj.isValid(val) || 'Este CNPJ parece estar incorreto, por favor, verifique para erros de digitação.',
        ]
    },
    inscricaoEstadual: {
        tipo: 'campo',
        largura: 6,
        label: 'Inscrição Estadual',
        autocomplete: 'off',
        icon: 'mdi-card-account-details',
        required: false,
        regras: []
    },
    nomeResponsavel: {
        tipo: 'campo',
        largura: 6,
        label: 'Nome do Responsável',
        autocomplete: 'name',
        icon: 'mdi-account',
        required: true,
        regras: []
    },
    email: {
        tipo: 'campo',
        largura: 6,
        label: 'Email',
        dica: 'Alterando este campo você deverá realizar uma verificação clicando no link do email que será enviado.',
        autocomplete: 'email',
        icon: 'mdi-email',
        required: true,
        regras: [
            val => val && isEmail(val) || 'Por favor, preencha um email valido',
        ]
    },
    celular: {
        tipo: 'campo',
        largura: 6,
        label: 'DDD + Celular',
        dica: 'Alterando este campo você deverá realizar uma verificação digitando o SMS enviado.',
        autocomplete: 'off',
        icon: 'mdi-cellphone',
        required: true,
        regras: [
            val => ![
                '11 11111-1111',
                '22 22222-2222',
                '33 33333-3333',
                '44 44444-4444',
                '55 55555-5555',
                '66 66666-6666',
                '77 77777-7777',
                '88 88888-8888',
                '99 99999-9999',
                '12 34567-8910',
                '11 12345-6789',
                '12 33214-5665',
                '12 34567-8912'
            ].includes(val) || 'Telefone Inválido',
        ],
        mascara: '## #####-####'
    },
    telefone: {
        tipo: 'campo',
        largura: 6,
        label: 'DDD + Telefone Fixo',
        autocomplete: 'off',
        icon: 'mdi-phone',
        required: false,
        regras: [
            val => ![
                '11 11111-1111',
                '22 22222-2222',
                '33 33333-3333',
                '44 44444-4444',
                '55 55555-5555',
                '66 66666-6666',
                '77 77777-7777',
                '88 88888-8888',
                '99 99999-9999',
                '12 34567-8910',
                '11 12345-6789',
                '12 33214-5665',
                '12 34567-8912'
            ].includes(val) || 'Telefone Inválido',
        ],
        mascara: '## #####-####'
    },
    telefoneRecado: {
        tipo: 'campo',
        largura: 6,
        label: 'DDD + Telefone para recado',
        autocomplete: 'off',
        icon: 'mdi-phone-in-talk',
        required: false,
        regras: [
            val => ![
                '11 11111-1111',
                '22 22222-2222',
                '33 33333-3333',
                '44 44444-4444',
                '55 55555-5555',
                '66 66666-6666',
                '77 77777-7777',
                '88 88888-8888',
                '99 99999-9999',
                '12 34567-8910',
                '11 12345-6789',
                '12 33214-5665',
                '12 34567-8912'
            ].includes(val) || 'Telefone Inválido',
        ],
        mascara: '## #####-####'
    },
    tituloEndereco: {
        tipo: 'titulo',
        texto: 'Endereço'
    },
    cep: {
        tipo: 'campo',
        largura: 6,
        label: 'CEP',
        autocomplete: 'postcode',
        icon: 'mdi-map-search',
        required: true,
        mascara: '#####-###',
        regras: [
            val => val && val.length >= 5 || 'CEP Inválido',
        ],
        onChange: async () => {
            if (form.cep.length > 6){
                let resultado;
                try {
                    console.log(route('utilidades.consultaCep', {cep: form.cep}))
                    $q.loading.show({
                        message: 'Procurando seu CEP...'
                    });
                    resultado = await (await fetch(route('utilidades.consultaCep', {cep: form.cep}), {
                        method: 'GET',
                        credentials: 'include'
                    })).json();

                    $q.loading.hide();
                    form.endereco = (resultado.nome) ? `${resultado.tipo} ${resultado.nome}` : '';
                    form.bairro = resultado.bairro.nome;
                    form.cidade = resultado.bairro.cidade.nome;
                    //form.estado = resultado.bairro.cidade.estado.nome;
                    form.estado = resultado.bairro.cidade.estado.codigo_uf;
                } catch (e) {
                    $q.notify({
                        icon: 'mdi-map-marker-remove',
                        message: 'O CEP fornecido não foi encontrado',
                        color: 'negative'
                    })
                }
            }
        }
    },
    estado: {
        tipo: 'campo',
        largura: 6,
        label: 'Estado',
        autocomplete: 'off',
        icon: 'mdi-map',
        required: true,
        opcoes: listaEstadoUF.value,
        readonly: false,
        regras: []
    },
    cidade: {
        tipo: 'campo',
        largura: 6,
        label: 'Cidade',
        autocomplete: 'off',
        icon: 'mdi-city-variant',
        required: true,
        readonly: false,
        regras: [
            val => val && val.length <= 100 || 'Cidade deve ser abreviada',
        ]
    },
    bairro: {
        tipo: 'campo',
        largura: 6,
        label: 'Bairro',
        autocomplete: 'off',
        icon: 'mdi-home-map-marker',
        required: true,
        readonly: false,
        regras: [
            val => val && val.length <= 100 || 'Bairro deve ser abreviado',
        ]
    },
    endereco: {
        tipo: 'campo',
        largura: 4,
        label: 'Rua',
        autocomplete: 'off',
        icon: 'mdi-map-marker-multiple',
        required: true,
        regras: [
            val => val && val.length <= 150 || 'Endereço deve ser abreviado',
        ]
    },
    numero: {
        tipo: 'campo',
        largura: 4,
        label: 'Número',
        autocomplete: 'off',
        icon: 'mdi-pin',
        required: true,
        regras: []
    },
    complemento: {
        tipo: 'campo',
        largura: 4,
        label: 'Complemento',
        autocomplete: 'off',
        icon: 'mdi-pin',
        required: false,
        regras: []
    },
    tituloExtra: {
        tipo: 'titulo',
        texto: 'Informações Extra'
    },
    // referencia: {
    //     tipo: 'campo',
    //     largura: 6,
    //     label: 'Senha',
    //     autocomplete: 'password',
    //     icon: 'mdi-key-variant',
    //     required: true,
    //     regras: [
    //         val => val && val.length >= 6 || 'Senha muito curta, ela deve ter 6 ou mais caracteres',
    //         val => val && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])/.test(val) || 'A senha deve ter ao menos uma letra minuscula, uma maiuscula e um caractere especial'
    //     ]
    // },
    // referenciaBancaria: {
    //     tipo: 'campo',
    //     largura: 6,
    //     label: 'Senha',
    //     autocomplete: 'password',
    //     icon: 'mdi-key-variant',
    //     required: true,
    //     regras: [
    //         val => val && val.length >= 6 || 'Senha muito curta, ela deve ter 6 ou mais caracteres',
    //         val => val && /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$&*])/.test(val) || 'A senha deve ter ao menos uma letra minuscula, uma maiuscula e um caractere especial'
    //     ]
    // },
    informacoesExtras: {
        tipo: 'campo',
        largura: 12,
        label: 'Informações Extras',
        autocomplete: 'password',
        icon: 'mdi-file-document-multiple-outline',
        required: false,
        regras: []
    },
};
</script>

<template>
    <Head title="Documentação Pessoa Jurídica" />
    <MainLayout>
        <q-page class="flex row justify-center items-start q-py-md">
            <div class="flex column items-center col-11">
                <h4
                    class="text-center text-primary font-weight-light q-ma-md q-mb-lg"
                    :class="$q.screen.gt.sm ? 'text-h4' : 'text-h5'">
                    Editar Meus Dados
                </h4>
                <q-form class="full-width" @submit="form.post(route('minha_conta.juridica.atualizar'))">
                    <form-row>
                        <template :key="indice" v-for="(config, campo, indice) in campos">
                            <template v-if="config.condicional === undefined || config.condicional.value">
                                <template v-if="config.tipo === 'titulo'">
                                    <form-group-label :text="config.texto" />
                                </template>
                                <template v-else>
                                    <form-input
                                        v-model="form[campo]"
                                        :autocomplete="config.autocomplete"
                                        :label="config.label"
                                        :rules="config.regras"
                                        :type="config.type"
                                        :icon="config.icon"
                                        :required="config.required"
                                        :largura="config.largura"
                                        :mascara="config.mascara"
                                        :opcoes="config.opcoes"
                                        :data="config.data"
                                        :readonly="config.readonly"
                                        :optionsFn="config.optionsFn"
                                        :dataDefaultYM="config.dataDefaultYM"
                                        @change="config.onChange"
                                    />
                                </template>
                            </template>
                        </template>
                    </form-row>
                    <q-btn
                        class="full-width"
                        color="primary"
                        label="Atualizar Meus Dados"
                        icon-right="mdi-arrow-right"
                        type="submit"
                        :loading="form.processing"
                    />
                </q-form>
            </div>
        </q-page>
    </MainLayout>
</template>
